// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__TetsW","item":"PaymentsMobile_item__1YgNv","label":"PaymentsMobile_label__3zYRC","amount":"PaymentsMobile_amount__3Drk6"};